export class FiltroAlunoTurma {
	
	beneficiario: string;
	cpf: string;
	idOficina: number;
	idTurma: number;
}